import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { Box, Typography, List, ListItem, ListItemText, Divider } from '@mui/material';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { CONFIG } from '../states/settings';
import { api_menu_list } from '../states/selector';

const UnifiedArchive = () => {
  const menuList = useRecoilValue(api_menu_list);
  const [archiveData, setArchiveData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!menuList || menuList.length === 0) return;

    (async () => {
      try {
        const archive = {};
        
        // 各メニューの記事を取得して統合
        for (const menu of menuList) {
          try {
            const url = CONFIG.API.INFO + menu.json_file.split('.')[0] + CONFIG.API.INFO_EX;
            // console.log(`統一アーカイブ: ${menu.group_name} のURL`, url);
            
            const response = await fetch(url);
            
            if (!response.ok) {
              console.error(`メニュー ${menu.group_name} のHTTPエラー:`, response.status, response.statusText);
              continue;
            }
            
            const contentType = response.headers.get('content-type');
            if (!contentType || !contentType.includes('application/json')) {
              console.warn(`メニュー ${menu.group_name} のContent-Typeエラー:`, contentType);
              continue;
            }
            
            const json = await response.json();
            const messages = json.messages || [];
            
            // console.log(`統一アーカイブ: ${menu.group_name} の記事数`, messages.length);
            
            // 各記事を年月別にグループ化
            messages.forEach(item => {
              const date = new Date(item.sent_at);
              const yearMonth = format(date, 'yyyy年MM月');
              
              if (!archive[yearMonth]) {
                archive[yearMonth] = [];
              }
              archive[yearMonth].push({
                ...item,
                group_name: menu.group_name
              });
            });
          } catch (error) {
            console.error(`メニュー ${menu.group_name} のデータ取得に失敗:`, error);
            console.error('エラーの詳細:', {
              name: error.name,
              message: error.message,
              stack: error.stack
            });
          }
        }

        // 年月でソート（新しい順）
        const sortedArchive = Object.keys(archive)
          .sort((a, b) => {
            const [yearA, monthA] = a.split('年');
            const [yearB, monthB] = b.split('月');
            const [yearB2, monthB2] = yearB.split('年');
            const monthB3 = monthB2.split('月')[0];
            
            if (yearA !== yearB2) {
              return parseInt(yearB2) - parseInt(yearA);
            }
            return parseInt(monthB3) - parseInt(monthA);
          })
          .reduce((result, key) => {
            result[key] = archive[key];
            return result;
          }, {});

        setArchiveData(sortedArchive);
        setLoading(false);
      } catch (error) {
        console.error('統一アーカイブデータの取得に失敗しました:', error);
        setLoading(false);
      }
    })();
  }, [menuList]);

  if (loading) {
    return (
      <Box sx={{ 
        bgcolor: '#f5f5f5', 
        p: 2, 
        borderRadius: 1,
        height: 'fit-content',
        position: 'sticky',
        top: '20px'
      }}>
        <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          アーカイブ
        </Typography>
        <Typography variant="body2" color="text.secondary">
          読み込み中...
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ 
      bgcolor: '#f5f5f5', 
      p: 2, 
      borderRadius: 1,
      height: 'fit-content',
      position: 'sticky',
      top: '20px'
    }}>
      <Typography variant="h6" component="h3" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
        アーカイブ
      </Typography>
      
      <List dense>
        {Object.entries(archiveData).map(([yearMonth, items]) => {
          // 年月から年と月を抽出してURLパラメータを作成
          const [year, month] = yearMonth.split('年');
          const monthNum = month.replace('月', '');
          
          return (
            <Box key={yearMonth}>
              <ListItem sx={{ px: 0 }}>
                <Link 
                  to={`${CONFIG.PAGE_ROOT_PATH}/archive/${year}/${monthNum}`}
                  style={{ 
                    textDecoration: 'none', 
                    color: 'inherit',
                    width: '100%'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = '#1565c0';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = 'inherit';
                  }}
                >
                  <ListItemText 
                    primary={yearMonth}
                    primaryTypographyProps={{
                      fontWeight: 'bold',
                      fontSize: '0.9rem',
                      color: '#1976d2'
                    }}
                    secondary={`${items.length}件`}
                    secondaryTypographyProps={{
                      fontSize: '0.8rem',
                      color: '#666'
                    }}
                  />
                </Link>
              </ListItem>
              
              <Divider sx={{ my: 1 }} />
            </Box>
          );
        })}
      </List>
    </Box>
  );
};

export default UnifiedArchive;
